import { Box, Stack } from "@mui/material";
import { Text } from "Components/Text";
import { DangerIcon } from "Assets/icons/notifications";
import { COLORS } from "constants/layout";
import { ChevronRight } from "@mui/icons-material";
import { SuggestedActionType } from "types/user";

interface MotivationBarProps {
  item: SuggestedActionType;
}

export default function MotivationBar({
  item,
}: MotivationBarProps) {

  if (!item?.title || !item?.desc || !item?.cta || !item?.url) return null;
  return (
    <Stack
      flexDirection="row"
      gap={1}
      alignItems={{
        xs: "flex-start",
        md: "center",
      }}
      sx={{
        backgroundColor: "#FFF",
        borderRadius: 2,
        paddingInline: {
          xs: 1.5,
          md: 3,
        },
        paddingBlock: {
          xs: 1,
          md: 1.5,
        },
        borderLeft: `4px solid ${COLORS.error[500]}`,
      }}
    >
      <Box
      >
        <DangerIcon style={{ flexShrink: 0 }} />
      </Box>
      <Stack
        direction={{
          xs: "column",
          md: "row",
        }}
        ml="0!important"
        gap={{
          xs: 0.5,
          md: 1,
        }}
        flex={1}
        justifyContent="space-between"
      >
        <Stack
          direction={{
            xs: "column",
            md: "row",
          }}
          gap={{
            xs: 0.5,
            md: 1,
          }}
          alignItems="baseline"
        >
          <Text
            sx={{
              fontSize: {
                xs: 12,
                md: 16,
              },
              fontWeight: 500,
            }}
          >
            {item?.title}
          </Text>
          <Text
            sx={{
              display: {
                xs: "none",
                md: "inline",
              },
              fontSize: {
                xs: 10,
                md: 14,
              },
            }}
          >
            {item?.desc}
          </Text>
        </Stack>
        <Stack direction="row" alignItems="center">
          <a href={item?.url} target="_blank" rel="noopener noreferrer">
            <Text
              sx={{
                fontSize: {
                  xs: 12,
                  md: 14,
                },
                fontWeight: 500,
              }}
              color={COLORS.error[500]}
            >
              {item?.cta}
            </Text>
          </a>
          <ChevronRight
            sx={{
              fontSize: {
                xs: 10,
                md: 12,
              },
              color: COLORS.error[500],
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
}
